import { DateTime } from 'luxon';
import { ChildWorkspaceBackend } from '../../../../../backend/src/core/workspace/workspace.gate';
import { AbstractFrontend } from '../../shared/core/abstract-prototype-object';

/* eslint-disable no-use-before-define */
import { AbstractBackend } from '../abstract-contract';
import { StripeProductType } from '../stripe/product.stripe';

export const trialPeriodDays = 14;

export interface WorkspaceComboBackend extends AbstractBackend {
  sk: string;
  title?: string;
  description?: string;
  tempUser?: TempUser;
  isDefault?: boolean;
  personalBoardId?: string;
  setupCode?: string;
  needSetup?: boolean;
  needSetupName?: boolean;
  pendingEmailList?: EmailToken[];

  backgroundColor?: string;

  totalFileSize?: number;

  timezone?: string;

  parentId?: string;
  isApprovedParentId?: boolean;

  settings?: WorkspaceBackendSettings;

  hourlyTaskList?: HourlyTask[];

  unsafeSubData?: any; //  ✅ Read, ✅ Write
  publicSubData?: WorkspacePublicSubData; //  ✅ Read, ❌ Write
  privateSubData?: WorkspacePrivateSubData; // ❌ Read, ❌ Write
}

export interface WorkspacePrivateSubData {
  hubspot?: {
    accessToken?: string;
  };
  slack?: {
    botToken?: string;
  };
}

export interface WorkspacePublicSubData {
  stripeSubscriptionIdList?: string[];
  checkoutItem?: any;
  trialStartTimeStr?: string;
  trialExpiredTimeStr?: string;
  trialType?: StripeProductType;
}

export enum WorkspaceItemType {
  workspacePlaceHolder = 'w', // Placeholder for workspace
  chargingHistory = 'c',
}

export function getWorkspaceSortKey(itemType: WorkspaceItemType) {
  return `${itemType}#`;
}

export interface SalesCycle {
  id: string;
  title: string;
  description: string;
}

export interface WorkspaceBackendSettings {
  salesCycleList: SalesCycle[];
  backgroundColor?: string;
  openAi?: {
    fileIdList: string[];
  };
}

export interface HourlyTask {
  id: string;
  taskType: HourlyTaskType;
  payload: SendSlackMessagePayload | SendWeeklyReportPayload;
  scheduledTimeStr?: string;
  status?: HourlyTaskStatus;
}

export enum HourlyTaskStatus {
  paused = 'paused',
  running = 'running',
}

export enum HourlyTaskType {
  sendSlackMessage = 'sendSlackMessage',
  sendWeeklyReport = 'sendWeeklyReport',
}

export interface SendWeeklyReportPayload {
  sendToEmailList: string[];
}

export interface SendSlackMessagePayload {
  channel: string;
  message: string;
  blocks?: any[];
  cron?: string;
}

export interface SendActivitySummary {
  channel: string;
  cron?: string;
  payload: any;
}

export interface GitHubInstallation {
  installationId: string;
  code: string;
}

export interface WorkspaceIndexPartial {
  id: string;
  sk: string;
  personalBoardId: string;
  isDefault: boolean;
}

export enum UserWorkspaceStatusType {
  normal = 'normal',
}

export interface TempUser {
  id: string;
  workspaceId: string;
  name: string;
  preferredName: string;
  lastName?: string;
  preferredNameAudio?: string;
  portraitUrl: string;
  email: string;
  status: UserWorkspaceStatusType;
  joinedTimeStr: string;
  isTempUser: boolean;
}

export interface Workspace extends AbstractFrontend {
  id: string;
  version: string;
  sk: string;
  title: string;
  description?: string;
  isDefault?: boolean;
  createdTime: DateTime;
  setupCode?: string;

  timezone?: string;

  settings?: WorkspaceBackendSettings;

  needSetup?: boolean;
  needSetupName?: boolean;
  pendingEmailList?: EmailToken[];

  parentId?: string;
  isApprovedParentId?: boolean;

  parentWorkspace?: Workspace;
  childWorkspaceList?: ChildWorkspaceBackend[];

  totalFileSize?: number;

  openai?: {
    userLength: number;
    systemLength: number;
  };

  hourlyTaskList?: HourlyTask[];

  unsafeSubData?: any; //  ✅ Read, ✅ Write
  publicSubData?: WorkspacePublicSubData; //  ✅ Read, ❌ Write
  privateSubData?: any; // ❌ Read, ❌ Write
}

export interface EmailToken {
  token: string;
  email: string;
}
